/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  SettleTransactionsSettlementsOptions,
  SettleTransactionsSettlementsStatus200,
  SettleTransactionsSettlementsStatus400,
  SettleTransactionsSettlementsStatus404,
  SettleTransactionsSettlementsStatus500,
} from '../types/SettleTransactionsSettlements'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { settleTransactionsSettlements } from '../clients/settleTransactionsSettlements'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const settleTransactionsSettlementsMutationKey = () =>
  [{ url: '/v1/transactions/settlements' }] as const

export function settleTransactionsSettlementsMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = settleTransactionsSettlementsMutationKey()
  return mutationOptions<
    SettleTransactionsSettlementsStatus200,
    ResponseErrorConfig<
      | SettleTransactionsSettlementsStatus400
      | SettleTransactionsSettlementsStatus404
      | SettleTransactionsSettlementsStatus500
    >,
    SettleTransactionsSettlementsOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return settleTransactionsSettlements({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Settle multiple transactions settlements in batch
 * {@link /v1/transactions/settlements}
 */
export function useSettleTransactionsSettlements<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SettleTransactionsSettlementsStatus200,
      ResponseErrorConfig<
        | SettleTransactionsSettlementsStatus400
        | SettleTransactionsSettlementsStatus404
        | SettleTransactionsSettlementsStatus500
      >,
      SettleTransactionsSettlementsOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? settleTransactionsSettlementsMutationKey()

  const baseOptions = settleTransactionsSettlementsMutationOptions(config) as UseMutationOptions<
    SettleTransactionsSettlementsStatus200,
    ResponseErrorConfig<
      | SettleTransactionsSettlementsStatus400
      | SettleTransactionsSettlementsStatus404
      | SettleTransactionsSettlementsStatus500
    >,
    SettleTransactionsSettlementsOptions,
    TContext
  >

  return useMutation<
    SettleTransactionsSettlementsStatus200,
    ResponseErrorConfig<
      | SettleTransactionsSettlementsStatus400
      | SettleTransactionsSettlementsStatus404
      | SettleTransactionsSettlementsStatus500
    >,
    SettleTransactionsSettlementsOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    SettleTransactionsSettlementsStatus200,
    ResponseErrorConfig<
      | SettleTransactionsSettlementsStatus400
      | SettleTransactionsSettlementsStatus404
      | SettleTransactionsSettlementsStatus500
    >,
    SettleTransactionsSettlementsOptions,
    TContext
  >
}
